import { render, staticRenderFns } from "./QaAvatar.vue?vue&type=template&id=67fb76e4&scoped=true&"
import script from "./QaAvatar.vue?vue&type=script&lang=js&"
export * from "./QaAvatar.vue?vue&type=script&lang=js&"
import style0 from "./QaAvatar.vue?vue&type=style&index=0&id=67fb76e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb76e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
